import styled from 'styled-components'
import { Button as AntButton } from 'src/components/Ant'
import { Icon as AntIcon } from 'antd'

export const Button = styled(AntButton)`
  margin-left: 0.5rem;
`

export const DrawerFooterDiv = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  > div > div {
    margin-left: 1rem;
  }
`

export const Icon = styled(AntIcon)`
  padding: 0.3rem 0 0 0.5rem;
`
